import { Component, input, output, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonacoCodeEditorComponent } from '@rapider/monaco-code-editor';

@Component({
  selector: 'rapider-dynamic-page-debugger',
  standalone: true,
  imports: [CommonModule, MonacoCodeEditorComponent],
  templateUrl: './dynamic-page-debugger.component.html',
  host: { class: 'flex flex-col h-full w-full' },
})
export class DynamicPageDebuggerComponent {
  // Inputs from the parent rendering engine
  public debugStatePayload = input<Record<string, any>>({});
  public debugEventsLog = input<any[]>([]);

  // Output to tell the parent to clear its log array
  public onClearEvents = output<void>();

  // Internal UI State
  public activeDebugTab = signal<'state' | 'events'>('state');

  // Computed formatting
  public debugStateString = computed(() =>
    JSON.stringify(this.debugStatePayload(), null, 2),
  );

  public clearDebugEvents(): void {
    this.onClearEvents.emit();
  }
}
